// extracted by mini-css-extract-plugin
export default {"crossSellPaper":"crossSellPaper__M2FlZ","previewWrapper":"previewWrapper__NGI3N","bookedVendorTile":"bookedVendorTile__ZjZhN"};